import { useQuery } from 'react-query';
import { Container } from 'reactstrap';

import { getProfile } from 'api/profile/getProfile';

const Dashboard = () => {
  const { data } = useQuery('profile', getProfile, {});

  return (
    <div className="page-content">
      <Container fluid>
        {' '}
        <div className="text-center h-auto">{JSON.stringify(data)}</div>{' '}
      </Container>
    </div>
  );
};

export default Dashboard;
